import script from "./DetailsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailsSection.vue?vue&type=script&lang=ts&setup=true"

import "./DetailsSection.vue?vue&type=style&index=0&id=d6c6c40e&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6c6c40e"]])

export default __exports__